/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDetailReturnPolicy_item$ref = any;
export type PdpSharedDetailReturnPolicy_item = {
    readonly returnPolicy: {
        readonly accept: unknown | null;
        readonly buyerCopy: {
            readonly returnCopy: string | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedDetailReturnPolicy_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailReturnPolicy_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "returnPolicy",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accept",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "buyerCopy",
          "storageKey": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "returnCopy",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '2773a5f7567877ccf34578b5282bc559';
export default node;
